export const navCopy = {
  skip_to_content: "Lewati ke konten",
  nav_documentation: "Dokumentasi",
  nav_documentation_short: "Dokumentasi",
  nav_download: "Unduh",
  nav_community: "Komunitas",
  nav_playground: "Area Bermain",
  nav_playground_short: "Bermain",
  nav_handbook: "Buku Saku",
  nav_tools: "Alat",
  nav_search_placeholder: "Cari Dokumentasi",
  nav_search_aria: "Cari di situs TypeScript",
  // let me know if you can't make this work in your lang:
  // TypeScript X.Y [stable][between?]Z.Y[beta/rc]
  nav_version_stable_prefix: "telah tersedia sekarang",
  nav_version_between: ", ",
  nav_version_beta_prefix: "saat ini dalam versi beta.",
  nav_version_rc_prefix: "memiliki kandidat rilis untuk dicoba.",
  nav_this_page_in_your_lang: "Halaman ini telah tersedia di bahasa Anda",
  nav_this_page_in_your_lang_open: "Buka",
  nav_this_page_in_your_lang_no_more: "Jangan munculkan kembali",
}
